import React, { useState,useEffect } from "react";
import { ChildImageContainer } from "../../Components/AddAChild/ChildImageContainer";
import BackIcon from "../../Assets/Icons/BackIcon";
import NavbarCustom from "../../Components/NavbarCustom";
import AddIcon from "../../Assets/Icons/AddIcon";
import { Link , useLocation, useNavigate} from "react-router-dom";
import { usePlayerAccount } from "../../APIContext/PlayerAccountContext";
import "./style.css";
import BackBtn from "../../Components/BackBtn/BackBtn";

export default function AddAChild() {
  const { players, fetchPlayers } = usePlayerAccount();
  const location = useLocation();
   const navigate = useNavigate();

  const [selectedChildId, setSelectedChildId] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const packageId = queryParams.get('id');

  const linkTo = packageId ? `/add-child-form?id=${packageId}` : `/add-child-form`;

  
  

  useEffect(() => {
    fetchPlayers();
  }, [fetchPlayers]);

  
  
  function handleChildSelect(id) {
    setSelectedChildId(id);
  }

  const handleProceed = () => {
    setIsDisabled(true)
    if (!packageId ) {
      alert("Please select a package first");
      return;
    }

    if (!selectedChildId) {
      alert("Please select a child first");
      return;
    }

    if (packageId && selectedChildId) {

      navigate(`/package-details?id=${packageId}&childId=${selectedChildId}`);
      setIsDisabled(false)
    }
    setIsDisabled(false)
  };

  return (
    <>
      <NavbarCustom />
      <div className="add-child-container">
        <div className="add-child-header">
            <div className="header-left">
              <BackBtn />
            </div>

            <div className="add-child-header-content">
              <h1 className="add-child-heading black-text-clip">
                For Whom You Are Purchasing?
              </h1>
              <p className="black-text-clip">Choose Your Child</p>
            </div>

            <div className="header-right" />
          </div>

        <div className="add-child-image-container">
          {players.length > 0 ? (
            players.map((child, index) => (
              <ChildImageContainer
                key={child.id}
                id={child.id}
                image={child.profile_picture}
                name={child.name}
                age={child.age}
                isSelected={selectedChildId === child.id}
                onSelect={handleChildSelect}
              />
            ))
          ) : (
            <p>No children found !</p>
          )}

          <Link to={linkTo} className="adding-image-container">
            <span className="adding-icon">
              <AddIcon />
            </span>
            <p className="child-overlay-text adding-child-text">
              {players.length > 0 ? "Add Another Child" : "Add Your Child"}
            </p>
          </Link>
        </div>

        {packageId && (
            <div className="add-child-proceed-button-container">
              <button onClick={handleProceed} className="proceed-button" disabled={isDisabled} 
                style={
                  isDisabled
                    ? { cursor: "not-allowed", background: "rgb(0 0 0 / 78%)"}
                    : {}
                }>  {isDisabled ? "Processing..." : "Proceed"}</button>
            </div>
          )}
        
      </div>

      
    </>
  );
}
